import {Component, ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams, Content } from 'ionic-angular';
import { UserProvider } from '../../providers/user';

import * as moment from 'moment';
import 'moment/locale/de';
import {FileTransferObject} from "@ionic-native/file-transfer";
import {LoadingProvider} from "../../providers/loading";
import {FileTransfer} from "@ionic-native/file-transfer";
import {File} from "@ionic-native/file";
import {FileOpener} from "@ionic-native/file-opener";

/**
 * Generated class for the MessagecenterReadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-messagecenter-read',
  templateUrl: 'messagecenter-read.html',
})
export class MessagecenterReadPage {
  @ViewChild(Content) content: Content;
  messages: any;
  constructor(private transfer: FileTransfer, private file: File, private fileOpener: FileOpener, public loadingProvider: LoadingProvider, public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider) {
    this.messages = this.navParams.get('messages');
  }

  ionViewDidLoad() {
    this.scrollBottom();
    console.log('ionViewDidLoad MessagecenterReadPage');
  }

  scrollBottom() {
      var that = this;
      setTimeout(function() {
          that.content.scrollToBottom();
      }, 300);
  }

  formatMessageDate(date: any) {
      return moment(date).format('dddd, D. MMMM YYYY');
  }

    openPDF(pdf: any, pdf_name: any) {
        console.log("try to download pdf => "+pdf);
        const fileTransfer: FileTransferObject = this.transfer.create();
        this.loadingProvider.show();
        fileTransfer.download(pdf, this.file.dataDirectory + pdf_name).then((entry) => {
            this.loadingProvider.hide();
            console.log("target => "+this.file.dataDirectory + pdf_name);
            console.log(entry);
            this.fileOpener.open(entry.toURL(), 'application/pdf')
                .then(() => console.log('File is opened'))
                .catch(e => console.log('Error opening file', e));
        }, (error) => {
            console.log(error);
            // handle error
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/messagecenter-read/messagecenter-read.ts